import { composerContinuePath } from './composerGuide';

export type GallerySite = {
  id: string;
  slug: string;
  type: string;
  label: string;
  title: string;
  subject: string;
  outcome: string;
  icon: string;
  /** Live product URL. When set, the card opens this site instead of Composer. */
  href?: string;
  /** Longer card copy. Falls back to subject. */
  description?: string;
};

export const GALLERY_SITES: GallerySite[] = [
  {
    id: 'st-my2sats',
    slug: 'my2sats',
    type: 'Gift commerce',
    label: 'Gift commerce',
    title: 'My 2 Sats',
    subject: 'Physical Bitcoin gift cards',
    outcome:
      'A physical Bitcoin gift kit: 21 premium 3.5x2" cards, 7 designs, a unique QR on every card, and a dashboard to assign, fund, and track each gift.',
    icon: 'ri-bit-coin-line',
    href: 'https://my2sats.app/',
    description:
      'Premium physical Bitcoin gift kits. 21 cards, 7 designs, unique QR on every card, and a dashboard to load, assign, and track each gift.',
  },
  {
    id: 'st-bagprint',
    slug: 'bagprint',
    type: 'Market research',
    label: 'Market research',
    title: 'bagprint',
    subject: 'Research before you bet',
    outcome:
      'A research app for prediction markets: pick a market, get a sourced position and confidence, then chat with the research before you place the bet.',
    icon: 'ri-line-chart-line',
    href: 'https://bagprint.ai',
    description:
      'Sourced research for prediction markets. Pick a market, get a position and confidence with cited sources, then chat with the research before you bet.',
  },
  {
    id: 'st-beatflipz',
    slug: 'beatflipz',
    type: 'Producer platform',
    label: 'Producer platform',
    title: 'BeatFlipz',
    subject: 'Producer websites that build careers',
    outcome:
      'A platform for music producers: a professional website, beat contests with cash prizes, Co-Sign sponsorship, and feedback that is not just a file store.',
    icon: 'ri-disc-line',
    href: 'https://beatflipz.com',
    description:
      'Producer websites that build careers. Contests, Co-Sign sponsorship, fan reactions, and a home for your music beyond the beat store.',
  },
  {
    id: 'st1',
    slug: 'harbor-ledger',
    type: 'Customer admin',
    label: 'Customer admin',
    title: 'Harbor Ledger',
    subject: 'CPA working copy of a 1040',
    outcome:
      'A CPA working copy of one client\'s Form HL-1040: numbered return lines, dollars and cents boxes, no dashboard chrome.',
    icon: 'ri-dashboard-line',
  },
  {
    id: 'st2',
    slug: 'atelier-no-7',
    type: 'Shop with checkout',
    label: 'Shop with checkout',
    title: 'Atelier No. 7',
    subject: 'Scent design for boutique hotels',
    outcome: 'A shop screen for a scent studio that blends custom fragrances for boutique hotels.',
    icon: 'ri-store-2-line',
  },
  {
    id: 'st3',
    slug: 'kiln-appointments',
    type: 'Booking site',
    label: 'Booking site',
    title: 'Kiln Appointments',
    subject: 'Ceramic-studio firing slots',
    outcome: 'A booking screen where ceramicists reserve a firing slot on a printed kiln timetable.',
    icon: 'ri-calendar-check-line',
  },
  {
    id: 'st4',
    slug: 'mara-voss-stills',
    type: 'Portfolio',
    label: 'Portfolio',
    title: 'Mara Voss Stills',
    subject: 'Photographer portfolio, one portrait',
    outcome: "A photographer's site: one portrait, a name, and three titles. No project grid.",
    icon: 'ri-camera-line',
  },
  {
    id: 'st5',
    slug: 'shiftboard',
    type: 'Internal app',
    label: 'Internal app',
    title: 'Shiftboard',
    subject: 'Restaurant-group ticket wall',
    outcome: 'A kitchen-ticket wall for a restaurant group. No sidebar, no metric cards.',
    icon: 'ri-bar-chart-line',
  },
  {
    id: 'st6',
    slug: 'salt-and-tide',
    type: 'Marketing',
    label: 'Marketing',
    title: 'Salt and Tide',
    subject: 'Coastal food magazine cover',
    outcome: 'A coastal food magazine cover. The photograph is the page; the UI is a caption.',
    icon: 'ri-article-line',
  },
];

export type GalleryPublicOutcome = {
  id: string;
  slug?: string;
};

export function galleryImageSrc(slug: string): string {
  return `/gallery/${slug}.png`;
}

export function isLiveGallerySite(site: GallerySite): boolean {
  return Boolean(site.href);
}

export function galleryCardHref(
  site: GallerySite,
  _publicOutcomes: GalleryPublicOutcome[],
): string {
  if (site.href) return site.href;
  return composerContinuePath(site.outcome);
}
